var app = angular.module('leonardo');

var PropertyGroupListFilter = function () {
  return function (account) {
    if (!account.groups || account.groups.length === 0) {
      return '-';
    }
    if (account.groups.length > 3) {
      return account.groups.length + ' properties';
    }
    var names = [];
    angular.forEach(account.groups, function(item) {
      names.push(item.name);
    });
    names.sort();
    return names.join(', ');
  };
};

app.filter('propertyGroupList', [PropertyGroupListFilter]);
